import { createReducer, on, Action } from '@ngrx/store';
import * as actions from './collection-type.actions';

const initialState: OLO.State.CollectionType = {
    orderTypeId: null,
    address: null,
    details: null,
};

export const collectionTypesReducerFn = createReducer<OLO.State.CollectionType>(
    initialState,
    on(actions.SetCollectionType, (state, action) => ({
        ...state,
        orderTypeId: action.orderTypeId,
        address: action.address,
        details: action.details,
    })),
    on(actions.PatchOrderTypeIdCollectionTypeValue, (state, action) => ({
        ...state,
        orderTypeId: action.orderTypeId,
    })),
    on(actions.PatchAddressCollectionTypeValue, (state, action) => ({
        ...state,
        address: action.address,
    })),
    on(actions.PatchDetailsCollectionTypeValue, (state, action) => ({
        ...state,
        details: action.details,
    })),
    on(actions.ResetCollectionTypeAddressAndDetails, (state) => ({
        ...state,
        address: initialState.address,
        details: initialState.details,
    })),
);

export function collectionTypesReducer(state: OLO.State.CollectionType | undefined, action: Action) {
    return collectionTypesReducerFn(state, action);
}
